import React, { useContext, useEffect, useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { toast } from "react-toastify";
import {
  faXmark,
  faFloppyDisk,
  faTrashAlt,
  faCircleMinus,
  faEdit,
} from "@fortawesome/free-solid-svg-icons";
import { Input } from "../../../components/Input";
import { cerrarNuevaSalida } from "../../../helpers/controlSidebarDerecha";
import { useUnidades } from "../../../hooks/test/useUnidades";
import Swal from "sweetalert2";
import { SocketContext } from "../../../context/SocketContext";
import Select from "react-select";
import { ActualizarTripulantesSalidas } from "../../customComponents/Modals/ActualizarTripulanteSalidas";
import { AddTiendas } from "../../customComponents/Modals/AddTiendas";
import { Spinner } from "react-bootstrap";
import { EditCreateTripulante } from "../../customComponents/Modals/ModalCreateEdit";

const initialStateFormFormatoSalida = {
  destino: [],
  fecha_salida: "",
  hora_salida: "",
  chofer_id: "",
  cel_operador: "",
  tripulacion: [],
  cel_tripulacion: "",
  observaciones: "",
  tiendas: [],
  unidad_id: "",
  unidad_numero: "",
  cajas: [],
  cajaSeleccionada: [],
  contenedor: "",
};
export const FormatoSalida = ({ unidad, clear, setClear, tiendas = [] }) => {
  const [form, setForm] = useState(initialStateFormFormatoSalida);
  const [isDelete, setIsDelete] = useState({
    state: false,
    tripulante_id: "",
  });
  const [cat_tiendas, setCatTiendas] = useState([]);
  const [loading, setLoading] = useState(false);
  const [choferes, setChoferes] = useState([]);
  const [maniobristas, setManiobristas] = useState([]);
  const [destinoSeleccionado] = useState("");
  const {
    getTiendasNegocio,
    getTiendasCedis,
    getTripulantesIdNegocio,
    postTipulantes,
    createRutas,
    postBitacora,
    getunidadesNegocio,
    putTripulantes,
    postViajeV2,
  } = useUnidades();
  const [isCajasChecked, setIsCajasChecked] = useState(true); // Para "SIN cajas" - Inicialmente checked
  const [isManiobraChecked, setIsManiobraChecked] = useState(true); // Para "SIN MANIOBRA" - Inicialmente checked
  const [tiendasSeleccionadas, setTiendasSeleccionadas] = useState(
    tiendas || []
  );
  const { socket } = useContext(SocketContext);
  const [mensaje, setMensaje] = useState("Cargando datos del viaje...");
  const [selectedTripulante, setSelectedTripulante] = useState(null);
  const { fecha_salida, hora_salida, chofer_id, tripulacion, observaciones } =
    form;
  const [cajaSeleccionada, setCajaSeleccionada] = useState([]);
  const [cat_caja, setCatCaja] = useState([]);
  const [actiModalTienda, setActiModalTienda] = useState(false); // Estado para controlar el modal de AddTiendas
  const modalTiendaClose = () => setActiModalTienda(false); // Función para cerrar el modal
  const modalTiendaShow = () => setActiModalTienda(true); // Función para abrir el modal
  const [tripulantes, setTripulantes] = useState([]);
  const [tripulacionSeleccionada, setTripulacionSeleccionada] = useState([]);
  const [showModalCrud, setShowModalCrud] = useState(false);
  const [cedisSeleccionadoEnModal, setCedisSeleccionadoEnModal] = useState(
    unidad?.cedis_id
  );

  const loadInfo = async () => {
    setMensaje("Cargando datos del viaje...");
    setLoading(true);
    /*Trae las tiendas */
    let resp = [];
    if (unidad.negocio_id !== 1) {
      resp = await getTiendasNegocio(unidad.negocio_id);
    } else {
      resp = await getTiendasCedis(unidad.cedis_id);
    }
    if (resp.ok) {
      setCatTiendas(resp.tiendas);
    } else {
      setCatTiendas([]);
    }
    resp = await getunidadesNegocio(unidad.negocio_id, 7);
    if (resp.ok) {
      setCatCaja(resp.unidades);
    } else {
      setCatCaja([]);
    }
    resp = await getTripulantesIdNegocio(unidad.negocio_id, 1);
    if (resp.ok) {
      setChoferes(resp.tripulantes);
    } else {
      setChoferes([]);
    }
    /*Trae los tripulantes para seleccionar */
    resp = await getTripulantesIdNegocio(unidad.negocio_id, 2);
    if (resp.ok) {
      setManiobristas(resp.tripulantes);
    } else {
      setManiobristas([]);
    }

    let tripulacion = await getTripulantesIdNegocio(unidad.negocio_id);
    if (tripulacion.ok) {
      setTripulantes(tripulacion.tripulantes);
    } else {
      setTripulantes([]);
    }

    setLoading(false);
  };

  const refreshTiendas = async () => {
    let resp = [];
    resp = await getTiendasNegocio(unidad.negocio_id);
    if (resp.ok) {
      setCatTiendas(resp.tiendas);
    } else {
      setCatTiendas([]);
    }
  };

  useEffect(() => {
    if (!unidad.unidad_id) return;
    loadInfo();
  }, [unidad]);

  const resetForm = () => {
    setForm({
      destino: [],
      fecha_salida: "",
      hora_salida: "",
      chofer_id: "",
      cel_operador: "",
      tripulacion: [],
      cel_tripulacion: "",
      observaciones: "",
      tiendas: [],
      cajas: [],
      cajaSeleccionada: [],
      unidad_id: "",
    });
    setTiendasSeleccionadas([]);
    setCatTiendas([]);
    setChoferes([]);
    setManiobristas([]);
    setIsCajasChecked(true); // Resetear isCajasChecked
    setIsManiobraChecked(true); // Resetear isManiobraChecked
    setCatCaja([]);
    setCajaSeleccionada([]);
    setTripulacionSeleccionada([]);
    setTripulantes([]);
  };
  useEffect(() => {
    if (clear) {
      resetForm();
      setClear(false);
    }
  }, [clear]);

  const addTienda = (tienda) => {
    setTiendasSeleccionadas([...tiendasSeleccionadas, tienda]);
  };
  const removeTienda = (index) => {
    let auxTiendas = tiendasSeleccionadas;
    auxTiendas.splice(index, 1);
    setTiendasSeleccionadas([...auxTiendas]);
  };
  const drawTienda = (tienda) => {
    let find = cat_tiendas.find((x) => x.tienda_id === parseInt(tienda));
    if (!find) return "Sin nombre";
    return find.tienda_nombre;
  };

  const handleChange = (event) => {
    // console.log("handleChange FUNCTION - Event Name:",event.target.name," Event Value:",event.target.value); // <---- ¡AÑADE ESTE console.log!
    setForm({
      ...form,
      [event.target.name]:
        typeof event.target.value === "string"
          ? event.target.value.toUpperCase()
          : event.target.value,
    });
  };

  const handleCedisModalChange = (newCedisId) => {
    setCedisSeleccionadoEnModal(newCedisId);
  };

  //ColoresTP
  const RojoTotalProtect = {
    color: "rgb(248, 2, 0)",
    fontSize: "2rem",
  };
  /**
   * Valida los datos del formulario
   * @returns boolean
   */
  const validaciones = () => {
    if (tiendasSeleccionadas.length === 0) {
      showToastError("No se ha seleccionado ningún destino");
      return false;
    }
    if (!form.fecha_salida) {
      showToastError("La fecha de salida es obligatoria");
      return false;
    }
    if (!form.hora_salida) {
      showToastError("La hora de salida es obligatoria");
      return false;
    }
    if (tripulacionSeleccionada.length === 0) {
      showToastError("Favor de seleccionar la tripulación");
      return false;
    }
    return true;
  };

  const actualizarTiposTripulantes = async () => {

    const actualizaciones = [];

    for (const seleccionado of tripulacionSeleccionada) {

      const original = tripulantes.find(
        x => x.tripulante_id === seleccionado.tripulante_id
      );

      if (!original) continue;

      const tipoDeseado = seleccionado.rol === "OPERADOR" ? 1 : 2;
      if (original.tipo_tripulante_id !== tipoDeseado) {
        actualizaciones.push(
          putTripulantes(
            seleccionado.tripulante_id,
            {
              tipo_tripulante_id: tipoDeseado,
            }
          )
        );
      }
    }

    await Promise.all(actualizaciones);
  };

  const saveForm = async (event) => {
    setMensaje("Programando viaje...");
    console.log("¡Función saveForm llamada!"); // <---- AGREGAR ESTE console.log
    event.preventDefault();
    setLoading(true);
    const flag = validaciones();
    if (!flag) {
      setLoading(false);
      return "";
    }
    const sinRol = tripulacionSeleccionada.filter(
      x => !x.rol
    );

    if (sinRol.length > 0) {
      setLoading(false);
      return Swal.fire({
        icon: "warning",
        text: "Toda la tripulacion debe tener un rol asignado",
      });
    }

    const operadoresIds = tripulacionSeleccionada
      .filter(item => item.rol === "OPERADOR")
      .map(item => item.tripulante_id);

    await actualizarTiposTripulantes();

    console.log(
      "saveForm - ANTES de postViaje - Valor de form.cajas:",
      form.cajas
    ); // <---- AÑADE ESTE console.log

    let resp = await postViajeV2({
      unidad_id: unidad.unidad_id,
      cedis_id: unidad.cedis_id,
      operadores: operadoresIds,
      descripcion: form.observaciones,
      fecha_hora_salida: `${form.fecha_salida} ${form.hora_salida}:00`,
      status: 2,
      cajas: form.cajas,
      complemento_viaje: form.contenedor,
    });

    if (!resp.ok) {
      setLoading(false);
      return Swal.fire({
        title: "Lo siento",
        text: resp.msg,
        icon: "info",
      });
    }
    let viajeId = resp.viaje_id;
    if (tripulacionSeleccionada.length > 0) {
      const soloTripulantes = tripulacionSeleccionada.filter(x => x.rol === "TRIPULANTE");
      resp = await postTipulantes({
        id_viaje: viajeId,
        tripulantes: soloTripulantes.map(x => ({
          tripulante_id: x.tripulante_id,
          rol: x.rol,
        })),
      });
    }

    if (tiendasSeleccionadas.length > 0) {
      resp = await createRutas({
        viaje_id: viajeId,
        tiendas: tiendasSeleccionadas,
      });
    }
    await postBitacora({
      id_viaje: viajeId,
      notas: "Se programó la salida de la unidad",
      id_status: 6,
    });

    socket.emit("traer-unidades-en-ruta_", {
      idNegocio: parseInt(unidad.negocio_id),
    });

    setLoading(false);
    resetForm();
    cerrarNuevaSalida();
    return Swal.fire({
      title: "La unidad ha sido programada",
      text: "Unidad programada para salir con éxito y ha sido guardada",
      icon: "success",
    });
  };
  /**
   * Muestra un mensaje de error
   * @param {String} msj
   */
  const showToastError = (msj = "Ha ocurrido un error") => {
    toast.error(msj, {
      position: "bottom-right",
      autoClose: 5000,
      hideProgressBar: false,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: true,
      progress: undefined,
    });
  };

  useEffect(() => {
    let arrayTripulacion = tripulacion;
    let index = arrayTripulacion.findIndex(
      (x) => x.tripulante_id === isDelete.tripulante_id
    );
    if (index >= 0) {
      arrayTripulacion.splice(index, 1);
      setIsDelete({
        state: false,
        tripulante_id: "",
      });
      if (arrayTripulacion.length === 0) setIsManiobraChecked(true);
      return handleChange({
        target: {
          name: "tripulacion",
          value: arrayTripulacion,
        },
      });
    }
  }, [isDelete]);

  const drawCaja = (cajas) => {
    let find = cat_caja.find((x) => x.unidad_id === parseInt(cajas));
    if (!find) {
      return "caja no registrada";
    }
    // console.log("drawCaja FUNCTION - Renderizando caja:", find.unidad_numero, " con unidad_id:", cajas, " form.cajas ACTUAL:", form.cajas, " cajaSeleccionada ACTUAL:", cajaSeleccionada); // <---- AÑADIR ESTE console.log
    return (
      <>
        <div className=" col-12" style={{ height: "3rem" }}>
          <div className="row" style={{ height: "3rem" }}>
            <FontAwesomeIcon
              className="fa-solid col-sm-1 mt-0"
              style={{ color: "#ff0000", height: "1rem" }}
              icon={faCircleMinus}
              onClick={() => {
                const updatedCajas = form.cajas.filter((x) => x !== cajas);
                setCajaSeleccionada(updatedCajas);
                handleChange({
                  target: { name: "cajas", value: updatedCajas },
                });
              }}
            />
            <h5 className="AzulTP col text-start">{find.unidad_numero}</h5>
          </div>
        </div>
      </>
    );
  };

  const subirTienda = (index) => {
    if (index === 0) return; // ya está arriba
    const arr = [...tiendasSeleccionadas];
    [arr[index - 1], arr[index]] = [arr[index], arr[index - 1]];
    setTiendasSeleccionadas(arr);
  };

  const bajarTienda = (index) => {
    if (index === tiendasSeleccionadas.length - 1) return; // ya está abajo
    const arr = [...tiendasSeleccionadas];
    [arr[index + 1], arr[index]] = [arr[index], arr[index + 1]];
    setTiendasSeleccionadas(arr);
  };

  return (
    <>
      <div
        className="card display-oculto animated fadeInRight top-0 end-0"
        id="sidebarNuevaSalida"
        style={{ position: "fixed", marginTop: "4rem" }}
      >
        <div className=" card-header" id="card-header">
          Programar salida
          <i className="icono-cerrar ">
            <FontAwesomeIcon
              onClick={() => {
                cerrarNuevaSalida();
                resetForm();
              }}
              style={RojoTotalProtect}
              icon={faXmark}
            />
          </i>
        </div>
        <div
          className="card-body"
          style={{ overflowY: "scroll", maxHeight: "83vh" }}
        >
          {loading ? (
            <>
              <div className="text-center">
                <Spinner animation="border" variant="primary"></Spinner>
                <p className="p-1">{mensaje}</p>
              </div>
            </>
          ) : (
            <form>
              <div className="card-title text-danger"></div>
              <label>
                <b>UNIDAD DE NEGOCIO: </b>
                {unidad?.negocio && unidad?.negocio?.negocio_nombre}
              </label>
              <br />
              <label>
                <b>
                  {unidad?.cat_tipos_almacen
                    ? unidad?.cat_tipos_almacen?.nombre
                    : "Cedis"}
                  &nbsp;
                </b>
                {unidad?.cedi && unidad?.cedi?.nombre_cedis}
                {unidad?.spot ? (
                  <b className="mt-n4">
                    {" "}
                    (SPOT {unidad?.nombre_transportadora})
                  </b>
                ) : (
                  ""
                )}
              </label>
              <br />
              <label>
                <b>UNIDAD:&nbsp;</b>
                {unidad?.unidad_numero}
              </label>
              <hr />
              <label>INDICA LOS DESTINOS</label>
              <div className="row">
                <div className="col-12 my-2 form-control selectCedis">
                  <Select
                    options={cat_tiendas.map((x) => {
                      let tienda = tiendasSeleccionadas.find(
                        (y) => y === x.tienda_id
                      );

                      return {
                        value: x.tienda_id,
                        label: x.tienda_nombre,
                        isDisabled: tienda ? true : false,
                      };
                    })}
                    className="mb-2"
                    classNamePrefix={"select"}
                    name="destino"
                    value={destinoSeleccionado}
                    onChange={(elemento) => {
                      addTienda(elemento.value);
                    }}
                    placeholder="Selecciona una tienda"
                    noOptionsMessage={() => (
                      <button
                        className="btn btn-sm mb-2"
                        onClick={() => {
                          modalTiendaShow();
                        }}
                      >
                        <strong>AGREGAR TIENDA</strong>
                      </button>
                    )}
                  />
                </div>
              </div>
              <br />
              {tiendasSeleccionadas.map((tienda, index) => (
                <div className="d-flex align-items-center mb-2 gap-2" key={index}>

                  {/* Botones de orden */}
                  <div className="d-flex flex-column">
                    <button type="button" className="btn btn-sm p-0 lh-1"
                      onClick={() => subirTienda(index)} disabled={index === 0}>
                      ▲
                    </button>
                    <button type="button" className="btn btn-sm p-0 lh-1"
                      onClick={() => bajarTienda(index)} disabled={index === tiendasSeleccionadas.length - 1}>
                      ▼
                    </button>
                  </div>

                  {/* Número de parada */}
                  <span className="badge bg-secondary">{index + 1}</span>

                  <small className="flex-grow-1">{drawTienda(tienda)}</small>

                  {/* Etiquetas de inicio y fin */}
                  {index === 0 && <span className="badge bg-primary">Inicio</span>}
                  {index === tiendasSeleccionadas.length - 1 && tiendasSeleccionadas.length > 1 && (
                    <span className="badge bg-success">Fin</span>
                  )}

                  <button type="button" className="btn btn-sm p-0" onClick={() => removeTienda(index)}>
                    <FontAwesomeIcon icon={faCircleMinus} style={{ color: "red" }} />
                  </button>

                </div>
              ))}
              {tiendasSeleccionadas.length > 0 ? (
                <>
                  {" "}
                  {/*boton para borrar todas las tiendas */}
                  <button
                    type="button"
                    onClick={() => {
                      setTiendasSeleccionadas([...[]]);
                    }}
                    className="btn btn-danger-b btn-block"
                  >
                    <FontAwesomeIcon icon={faTrashAlt} /> &nbsp; Borrar
                  </button>
                  <br />
                </>
              ) : (
                <>
                  {" "}
                  {/*Aun no se selecciona el destino */}
                  <p className="AzulTP text-center">
                    <small>No se ha seleccionado ningún destino </small>
                  </p>
                </>
              )}
              <br />
              <hr />

              <label>SELECCION DE CAJAS</label>
              <div className="row my-2">
                <div className="col-12">
                  <input
                    className=""
                    id="checkCajas"
                    type={"checkbox"}
                    checked={isCajasChecked}
                    onChange={(event) => {
                      setIsCajasChecked(event.target.checked);
                      if (event.target.checked) {
                        setForm({
                          ...form,
                          cajas: [],
                        });
                        setCajaSeleccionada([]);
                      }
                    }}
                  ></input>
                  <label htmlFor="checkCajas" className="ps-2">
                    SIN CAJA
                  </label>
                </div>
              </div>
              {!isCajasChecked && (
                <>
                  <div>
                    <div className="mb-3 col-12 form-control selectCedis">
                      {cat_caja && ( // condicional que renderiza si la caja si es true
                        <Select
                          options={cat_caja.map((x) => {
                            let find = cajaSeleccionada.find(
                              (y) => y === x.unidad_id
                            );
                            return {
                              value: x.unidad_id,
                              label: `${x.unidad_numero}`, // Modificamos el label para indicar si está ocupada
                              isDisabled:
                                !x.unidad_disponible || (find ? true : false), // Deshabilitamos la opción si está ocupada o ya está seleccionada
                            };
                          })}
                          className="mb-2"
                          name="unidad_numero"
                          value={cajaSeleccionada}
                          onChange={(elemento) => {
                            if (form.cajas.length >= 2)
                              return Swal.fire({
                                title: "¡Lo siento!",
                                text: "Solo puedes agregar máximo 2 cajas",
                                icon: "info",
                              });
                            const arrayCajas = [...form.cajas, elemento.value];
                            setCajaSeleccionada(arrayCajas);
                            handleChange({
                              // Llama a handleChange para actualizar el estado form.cajas
                              target: {
                                name: "cajas",
                                value: arrayCajas,
                              },
                            });
                            console.log(
                              "Select de Cajas - onChange - Estado form.cajas DESPUÉS de actualizar:",
                              form.cajas
                            ); // <---- AÑADE ESTE console.log
                          }}
                          placeholder="Selecciona una caja"
                        />
                      )}
                    </div>
                  </div>
                  {cajaSeleccionada.length === 0 && !isCajasChecked && (
                    <p className="AzulTP text-center">
                      <small>Sin caja seleccionada</small>
                    </p>
                  )}
                  {cajaSeleccionada.map((x, index) => {
                    return (
                      <h1 className="mt-0" key={index}>
                        {drawCaja(x)}
                      </h1>
                    );
                  })}
                </>
              )}
              <br />
              <div className="col-12">
                <div class="mb-3">
                  <label for="formGroupExampleInput" class="form-label">Contenedor o remolque sin GPS</label>
                  <input
                    type="text"
                    class="form-control"
                    id="formGroupExampleInput"
                    placeholder=""
                    name="contenedor"
                    value={form.contenedor}
                    onChange={handleChange}
                  />
                </div>
              </div>
              <hr />
              <div className="row">
                <div className="col-6">
                  <label>FECHA DE SALIDA*</label>
                  <Input
                    attribute={{
                      name: "fecha_salida",
                      type: "date",
                      className: "form-control control-input",
                      required: "required",
                      id: "fechaActual",
                    }}
                    value={fecha_salida}
                    onChange={handleChange}
                  />
                </div>
                <div className="col-6">
                  <label>HORA DE SALIDA*</label>
                  <Input
                    attribute={{
                      id: "idHoraSalida",
                      name: "hora_salida",
                      type: "time",
                      className: "form-control control-input",
                      required: "required",
                    }}
                    value={hora_salida}
                    onChange={handleChange}
                  />
                </div>
              </div>
              <br />
              <div className="row"></div>
              <br />
              <Select
                isMulti
                options={tripulantes.map((x) => {
                  const yaSeleccionado =
                    tripulacionSeleccionada.find(
                      y => y.tripulante_id === x.tripulante_id
                    );

                  return {
                    value: x.tripulante_id,
                    label: `${x.nombre_completo} ${x.telefono}`,
                    data: x,

                    isDisabled:
                      x.ocupado ||
                      (
                        tripulacionSeleccionada.length >= 4 &&
                        !yaSeleccionado
                      ),
                  };
                })}
                className="mb-2"
                classNamePrefix={"select"}
                placeholder="Selecciona tripulación"
                noOptionsMessage={({ inputValue }) => (
                  <button
                    className="btn btn-sm mb-2"
                    type="button"
                    onClick={() => setShowModalCrud(true)}
                  >
                    <strong>+ AGREGAR TRIPULANTE "{inputValue}"</strong>
                  </button>
                )}
                value={tripulacionSeleccionada.map(p => ({
                  value: p.tripulante_id,
                  label: `${p.nombre} ${p.telefono}`,
                  data: { nombre_completo: p.nombre, telefono: p.telefono, tipo_tripulante_id: p.tipo_tripulante_id },
                }))}
                onChange={(elementos) => {

                  const nuevaLista = elementos.map((x) => {

                    // conservar tipo si ya existía
                    const existente = tripulacionSeleccionada.find(
                      y => y.tripulante_id === x.value
                    );

                    return {
                      tripulante_id: x.value,
                      nombre: x.data.nombre_completo,
                      telefono: x.data.telefono,
                      rol: existente?.rol || null,
                      tipo_tripulante_id: x.data?.tipo_tripulante_id,
                    };
                  });

                  setTripulacionSeleccionada(nuevaLista);
                }}
              />
              {(() => {
                const operadores = tripulacionSeleccionada.filter(x => x.rol === "OPERADOR");
                const tripulantesRol = tripulacionSeleccionada.filter(x => x.rol === "TRIPULANTE");

                return tripulacionSeleccionada.map((persona) => {

                  return (
                    <div
                      className="card p-3 mb-2"
                      key={persona.tripulante_id}
                    >

                      {/* FILA SUPERIOR */}
                      <div className="row">
                        <div className="col-12 text-center">

                          <strong className="fs-6">
                            {persona.nombre}
                          </strong>
                          <br />
                          <small className="text-muted">
                            {persona.telefono}
                          </small>

                          <br />
                        </div>
                      </div>

                      {/* FILA BOTONES */}
                      <div className="row mt-3">
                        <div className="col-12">
                          <div className="d-flex justify-content-center gap-2">

                            <button
                              type="button"
                              style={{ padding: "5px" }}
                              className={
                                persona.rol === "OPERADOR"
                                  ? "btn btn-primary"
                                  : "btn btn-outline-primary"
                              }
                              onClick={() => {
                                setTripulacionSeleccionada(prev => {
                                  const operadoresActuales = prev.filter(
                                    x => x.rol === "OPERADOR" && x.tripulante_id !== persona.tripulante_id
                                  );
                                  if (operadoresActuales.length >= 2) {
                                    Swal.fire({ icon: "warning", text: "Solo puedes seleccionar máximo 2 operadores" });
                                    return prev;
                                  }
                                  return prev.map(x =>
                                    x.tripulante_id === persona.tripulante_id
                                      ? { ...x, rol: "OPERADOR", tipo_tripulante_id: 1 }
                                      : x
                                  );
                                });
                              }}
                            >
                              Conductor
                            </button>

                            <button
                              type="button"
                              style={{ padding: "5px" }}
                              className={
                                persona.rol === "TRIPULANTE"
                                  ? "btn btn-success"
                                  : "btn btn-outline-success"
                              }
                              onClick={() => {
                                setTripulacionSeleccionada(prev => {
                                  const tripulantesActuales = prev.filter(
                                    x => x.rol === "TRIPULANTE" && x.tripulante_id !== persona.tripulante_id
                                  );
                                  if (tripulantesActuales.length >= 2) {
                                    Swal.fire({ icon: "warning", text: "Solo puedes seleccionar máximo 2 tripulantes" });
                                    return prev; // no modifica nada
                                  }
                                  return prev.map(x =>
                                    x.tripulante_id === persona.tripulante_id
                                      ? { ...x, rol: "TRIPULANTE", tipo_tripulante_id: 2 }
                                      : x
                                  );
                                });
                              }}
                            >
                              Acompañante
                            </button>

                          </div>
                        </div>
                      </div>
                    </div>
                  );
                });
              })()}
              < br />
              <label>OBSERVACIONES O COMENTARIOS</label>
              <textarea
                className="form-control control-input mt-2"
                placeholder="DESCRIPCIÓN DE LA UNIDAD O SALIDA"
                name="observaciones"
                value={observaciones}
                onChange={handleChange}
              ></textarea>
              <br />
              <div
                className="card-footer bg-transparent border-dark text-center"
                style={{ marginBottom: "30px" }}
              >
                <div className="text-center">
                  <button
                    type="submit"
                    className="btn btn-default-g cursor"
                    disabled={loading}
                    onClick={saveForm}
                  >
                    <span>
                      <FontAwesomeIcon icon={faFloppyDisk} />
                    </span>
                    &nbsp;Guardar
                  </button>
                  <br />
                </div>
                <br />
              </div>
            </form>
          )}
        </div>
      </div>

      {actiModalTienda ? (
        <AddTiendas // <---- ¡RENDERIZA AddTiendas AQUÍ!
          show={actiModalTienda} // Prop para controlar la visibilidad del modal
          handleClose={modalTiendaClose} // Prop para cerrar el modal
          onTiendaSaved={refreshTiendas} // Prop para refrescar la lista de tiendas
          unidad={unidad.cedi ? unidad.cedi.nombre_cedis : "No existe"} // Pasamos una copia de unidad con el cedis actualizado
          cedis_id={unidad.cedi ? unidad.cedi.cedis_id : null}
          idNegocio={unidad.negocio_id}
          onCedisChange={handleCedisModalChange} // Pasamos la función para actualizar el estado
        />
      ) : (
        ""
      )}

      {
        <EditCreateTripulante
          negocio_id={unidad.negocio_id}
          show={showModalCrud}
          handleClose={() => setShowModalCrud(false)}
          refreshTripulantes={async () => {
            await loadInfo();        // refresca choferes, maniobristas y tripulantes
          }}
        />
      }
    </>
  );
};
